import styled from 'styled-components';
import { Background } from 'components/Generics/Background/Background.style';
export const Content = styled.div`
    height: 82%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
`;

export {
    Background
};